import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import eventBus from 'EventBus.js';
import util from 'util/Util.js';
import nameTemplate from 'properties/style/frame.ejs';
import { pickerCfg } from 'pickerCfg.js';
import constants from 'Constants.js';

class StyleFrameView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]': 'updateCheckboxAttributes',
            'change input[type=text]': 'updateAttributes',
            'change input[type=color]': 'updateColorAttributes',
            'change #frame': 'updateVisibility',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (propName === 'frameSize') {
            this.model.set(propName, propVal);
            eventBus.trigger('frameWidthSet', propVal);
        } else {
            if (super.updateColorAttributesWithValidation(ev) && propName === "frameColor") {
                eventBus.trigger('frameColorSet', propVal);
            }
        }
    }

    updateColorAttributes(ev) {
        super.updateColorAttributes(ev);

        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        if (propName === "frameColor") {
            eventBus.trigger('frameColorSet', propVal);
        }
    }

    updateCheckboxAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.checked;

        this.model.set(propName, propVal);
        if (propName === 'frameRoundCorners') {
            eventBus.trigger('roundCornersSet', propVal);
        } else if (propName === 'frame') {
            eventBus.trigger('showFrameSet', propVal);
        }
    }

    updateVisibility(ev) {
        if (ev) {
            ev.preventDefault();
        }

        if (util.isTrue(this.model.get('frame'))) {
            $('.isFrameActive').removeClass(constants.CLASS_HIDDEN);
            $('.isFrameActive :input').attr('disabled', false);
        }
        else {
            $('.isFrameActive').addClass(constants.CLASS_HIDDEN);
            $('.isFrameActive :input').attr('disabled', true);
        }
    }


    render() {
        super.render();

        if (this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        $('#frame').prop('checked', util.isTrue(this.model.get('frame')));
        $('#frameRoundCorners').prop('checked', util.isTrue(this.model.get('frameRoundCorners')));

        this.updateVisibility();

        this.delegateEvents();

        return this;
    }

}

export default StyleFrameView;
